import { render } from "./GenreCard.vue?vue&type=template&id=5e701c42&scoped=true"
import script from "./GenreCard.vue?vue&type=script&lang=js"
export * from "./GenreCard.vue?vue&type=script&lang=js"

import "./GenreCard.vue?vue&type=style&index=0&id=5e701c42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e701c42"

export default script